import type { RouteRecordRaw } from 'vue-router'
import PageHome from '@/views/home/page-home.vue'
import PageProductUnit from '@/views/product-unit/page-detail.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: PageHome,
    meta: { title: 'Eurogold' },
  },
  {
    path: '/:code',
    name: 'product unit show',
    component: PageProductUnit,
    meta: { title: 'Eurogold' },
  },
]

export default routes
